function setDataset(element: HTMLElement, key: string, value: string): void {
    //
    element.dataset[key] = value;
}

// ----------------------------------------------------------------------------

export default setDataset;
